import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { SiteProvider } from "@/context/SiteContext";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminEdit from "@/pages/AdminEdit";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 48, fontFamily: "sans-serif", background: "#FBF6F1", minHeight: "100vh" }}>
          <h1 style={{ fontSize: 22 }}>Something went wrong</h1>
          <pre style={{ whiteSpace: "pre-wrap", color: "#5F5670" }}>{String(this.state.error)}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

function SmoothScroll() {
  useEffect(() => {
    let lenis = null;
    let raf = 0;
    let cancelled = false;
    import("lenis")
      .then(({ default: Lenis }) => {
        if (cancelled) return;
        lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
        window.__lenis = lenis;
        const loop = (time) => {
          lenis.raf(time);
          raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
      cancelAnimationFrame(raf);
      if (lenis) lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <LanguageProvider>
        <SiteProvider>
          <BrowserRouter>
            <SmoothScroll />
            <ScrollToTop />
            <div className="grain-overlay" aria-hidden="true" />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/edit" element={<AdminEdit />} />
            </Routes>
          </BrowserRouter>
        </SiteProvider>
      </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;
